import constants from '../../../../../settings/constants';
import products from '../../../../../services/products';
import productService from '../../../../../services/products';
import geometry from '../../../../../scene/util/geometry';
import validationErrors from '../validationErrors';
import { ITEMS } from '../../../../../constants';

const bottom = [0, 1, 2];

/**
 * Items that should not count towards stability in a section.
 */
const nonStabilityItems = [ITEMS.DRAWER];

/**
 * Checks if an item is not considered to contribute towards stability in a section.
 * @param {object} item
 * @returns {boolean}
 */
const isPartOfNonStabilityItems = item => {
  return nonStabilityItems.some(nonStabilityItem =>
    productService.isType(item, nonStabilityItem)
  );
};

/**
 * Removes the items that do not contribute towards stability in a section.
 * @param {array} items
 * @returns {Array<object>}
 */
const filterOutNonStabilityItems = items => {
  return items.filter(item => !isPartOfNonStabilityItems(item));
};

/**
 * The amount of items that contribute to stability, that need to be inserted into a section
 * for it to be stable.
 */
const stabilityItemsRequired = {
  sections: {
    1900: 4,
    1100: 3,
  },
};

/**
 * Gets the section height.
 * @param {object} section
 * @returns {number}
 */
const getSectionHeight = section => {
  return section.filter.height;
};

/**
 * Retrieves the amount of required items that contribute to stability, that is
 * required to be inserted into the section.
 * @param {object} section
 * @returns {boolean}
 */
const getRequiredAmountOfStabilityItems = section => {
  const height = getSectionHeight(section);
  return stabilityItemsRequired.sections[`${height}`];
};

function validate(tac) {
  // All sections must have a shelf at the top, middle and bottom to ensure stability
  return tac.items.reduce((errors, item) => {
    if (products.isSection(item)) {
      const stabilityItems = filterOutNonStabilityItems(item.items);

      const amountOfStabilityItemsInSection = (stabilityItems || []).reduce(
        (indices, childItem) => {
          if (!geometry.extendsOutside(childItem, item, 'x')) {
            indices.push(
              Math.round(childItem.y / constants.DISTANCE_BETWEEN_ATTACHMENTS)
            );
          }

          if (products.isCabinet(childItem)) {
            indices.push(
              Math.round(
                (childItem.y + childItem.height) /
                  constants.DISTANCE_BETWEEN_ATTACHMENTS
              )
            );
          }

          return indices;
        },
        []
      );
      const topIndex = constants.NBR_OF_ATTACHMENTS[item.height] - 1;
      const top = bottom.map(index => topIndex - index);

      if (
        amountOfStabilityItemsInSection.length <
        getRequiredAmountOfStabilityItems(item)
      ) {
        errors.push({
          ...validationErrors.INSERTS_TOO_FEW,
          itemid: item.itemid,
        });
      } else if (
        bottom.every(
          index => !amountOfStabilityItemsInSection.includes(index)
        ) ||
        top.every(index => !amountOfStabilityItemsInSection.includes(index))
      ) {
        errors.push({
          ...validationErrors.STABILITY_ZONES_UNCOVERED_BROR,
          itemid: item.itemid,
        });
      }
    }

    return errors;
  }, []);
}

export default { validate };
